import { Translatable } from '@app/types/translatable.type';

export const DocumentStatusDisplayOptions: { [key: string]: Translatable } = {
    notAcknowledged: 'document.notAcknowledged',
};

export const SignatureRequestStatusDisplayOptions: { [key: string]: Translatable } = {
    creating: 'document.signatureRequestStatus.creating',
    pending: 'document.signatureRequestStatus.pending',
    notSigned: 'document.signatureRequestStatus.notSigned',
    blocked: 'document.signatureRequestStatus.blocked',
};
